export default __webpack_public_path__ + "static/logo-animated-cb9c88cadde7145d19a926aa2cf3db06.gif";